import React from "react";
import "./ContactSpotlight.css";

function ContactSpotlight() {
  return (
    <div className="contactspotlight">
      <div className="content">
        <h3>Get in touch with us today</h3>
        <p>
          to learn more about our services, and how we can achieve your goals
        </p>
      </div>
    </div>
  );
}

export default ContactSpotlight;
